import { useReducer } from 'react';
import { v4 } from 'uuid';
import { CheckoutComponentNotificationType } from '../types/builder';

export type Notification = {
  id: string;
  message: string;
  exibitionTime: number;
  type: CheckoutComponentNotificationType;
};

type ReducerState = {
  notifications: Notification[];
};

enum ActionTypes {
  NOTIFY = 'notify',
  DISMISS = 'dismiss',
  CLEAR = 'clear'
}

type Action<T extends ActionTypes, P> = {
  type: T;
  payload: P;
};

type NotifyAction = Action<
  ActionTypes.NOTIFY,
  { message: string; type: CheckoutComponentNotificationType; exibitionTime: number }
>;

type DismissAction = Action<ActionTypes.DISMISS, { id: string }>;
type ClearAction = Action<ActionTypes.CLEAR, void>;

const reducer = (state: ReducerState, action: NotifyAction | DismissAction | ClearAction) => {
  switch (action.type) {
    case ActionTypes.NOTIFY:
      return {
        ...state,
        notifications: [
          ...state.notifications,
          {
            id: v4(),
            message: action.payload.message,
            type: action.payload.type,
            exibitionTime: action.payload.exibitionTime,
          }
        ]
      };
    case ActionTypes.DISMISS:
      return {
        ...state,
        notifications: state.notifications.filter(
          (notification) => notification.id !== action.payload.id
        )
      };
    case ActionTypes.CLEAR:
      return { ...state, notifications: [] };
    default:
      return state;
  }
};

const initialState: ReducerState = {
  notifications: []
};

const useNotifications = () => {
  const [{ notifications }, dispatch] = useReducer(reducer, initialState);

  const notify = (
    message: string,
    type: CheckoutComponentNotificationType,
    exibitionTime: number
  ) => {
    dispatch({ type: ActionTypes.NOTIFY, payload: { message, type, exibitionTime } });
  };

  const dismiss = (id: string) => {
    dispatch({ type: ActionTypes.DISMISS, payload: { id } });
  };

  const clear = () => {
    dispatch({ type: ActionTypes.CLEAR, payload: undefined });
  };

  return { notifications, notify, dismiss, clear };
};

export default useNotifications;
